import { render } from "./ModalView.vue?vue&type=template&id=364006d6&ts=true"
import script from "./ModalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ModalView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "364006d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('364006d6', __exports__)) {
    api.reload('364006d6', __exports__)
  }
  
  module.hot.accept("./ModalView.vue?vue&type=template&id=364006d6&ts=true", () => {
    api.rerender('364006d6', render)
  })

}


export default __exports__